import { useEffect, useMemo, useState } from 'react';
import type { Socket } from 'socket.io-client';
import { SocketNamespace } from '@trinity/chat';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useProjectSocket = (projectId: number): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Projects);

  const logger = useMemo(() => createLogger({
    namespace: SocketNamespace.Projects,
  }), []);

  useEffect(() => {
    if (projectId) {
      logger.log(`Setting up socket for project: ${projectId}`);
      const newSocket = getSocket();

      setSocket(newSocket);

      logger.log(`Subscribing to project: ${projectId}`);
      newSocket.emit('subscribe', projectId);

      return () => {
        logger.log(`Cleaning up socket for project: ${projectId}`);
        newSocket.emit('unsubscribe', projectId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, logger, projectId]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Projects);

  return socket;
};